import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../services/UserContext";

export default function ProtectedRoute() {
  const { user } = useContext(UserContext);

  // Si no hay usuario, redirigir a login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
